import React, { useEffect, useState } from "react";
import { API_BASE_URL, STATIC_SERVER_URL } from "../../../config/config";
import Spinner from "components/shared/Spinner/Spinner";
import { Link } from "react-router-dom";

import "./weekly-products.scss";
import ArrowIcon from "components/shared/SVG/ArrowIcon";

function WeeklyProducts(props) {
  const [productData, setProductData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeItem, setActiveItem] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE_URL}/weekly-products`)
      .then((res) => res.json())
      .then(
        (json) => {
          setIsLoaded(true);
          setProductData(json);
        },
        (error) => {
          setIsLoaded(true);
        }
      );
  }, []);

  if (!isLoaded) {
    return <Spinner />;
  }

  if (productData.length === 0) {
    return null;
  }

  return (
    <div className="weekly-products-container">
      <div className="logo-container">
        <img className="weekly-product-logo" src={`${STATIC_SERVER_URL}/web/images/shop/het-kepe-logo.png`} alt="Heti ajánlat" />
      </div>
      <div className="weekly-products-list">
        {productData.map((item, key) => (
          <div key={key} className={`weekly-products-item ${activeItem === key ? "active" : ""}`}>
            <div className="weekly-products-item-info">
              <h3>{item.name}</h3>
              <p className="discount-price">Akciós ár꞉ {item.discount_price.toLocaleString()} Ft</p>
              <p className="price">Eredeti ár: {item.price.toLocaleString()} Ft</p>
              <div className="button-container">
                <Link className="btn btn-primary" to={`/termek/${item.item_no}`}>
                  részletek
                </Link>
              </div>
            </div>
            <div className="weekly-products-item-images">
              {item.photos.slice(0, 3).map((photo, index) => (
                <img key={index} src={`${STATIC_SERVER_URL}/web/images/shop/products/${photo}`} alt={item.name} />
              ))}
            </div>
          </div>
        ))}
      </div>
      {productData.length > 1 && (
        <div className="pager-container">
          <button title="következő termék" type="button" className="btn-pager" onClick={() => setActiveItem(activeItem === productData.length - 1 ? 0 : activeItem + 1)}>
            <ArrowIcon />
          </button>
        </div>
      )}
    </div>
  );
}

export default WeeklyProducts;
